export default "__VITE_ASSET__B75m2qbo__"